import React, { Component } from 'react';
import axios from 'axios'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { Form, Segment, Button, Divider, } from 'semantic-ui-react'
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class AckMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }


    ackMessage = () => {
        console.log("ackm1 ++++++++:ackMessage");
        console.log("ackm12 messageId:" + this.props.messageId)
        console.log("ackm13 this.props.user.email:" + this.props.user.email)

        if (this.props.messageId == '') {
            alert("No messageId Person")
        } else if (this.props.user.email == '') {
            alert("No user Provided")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'ackMessage', {
                apiKey: "asdfasd##",
                messageId: this.props.messageId,
                enteredBy: this.props.user.email
            })
                .then((response) => {
                    this.setState({loading: false})
                    console.log("ackm14:" + response.data);

                    if (response.data.result) {
                        console.log("ackm15 true.. acking message");

                        alert(response.data.message);
                        this.props.getSmsMessageFromPhone()
                    } else {
                        console.log("ackm16 FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const buttonUI = this.props.message.acknowledged
            ? <h4>acked by {this.props.message.acknowledgedby}</h4>
            : <Form size='large' onSubmit={this.ackMessage}>
            <Button color='teal'>ACKNOWLEDGE </Button>
        </Form>

        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>
                
            {buttonUI}

            </div>);
    }
}

export default AckMessage;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/SmsFromPhone/AckMessage.js